import { SwitchButton } from "@/ui/switch-button";
import TpSlProfileModalWithBtnV2 from "../../tp-sl-profiles/tp-sl-profile-modal-with-btn-v2";

const AutoSellButtonsV2 = ({
  isAutoSell,
  setIsAutoSell,
}: {
  isAutoSell: boolean;
  setIsAutoSell: (v: boolean) => void;
}) => {
  return (
    <div className="flex flex-col gap-[0.3125rem] mt-[0.938rem]">
      <span className="text-xs font-semibold">Auto Sell</span>
      <div className="h-[1.875rem]">
        <SwitchButton
          className="gap-[0.375rem]"
          options={["On", "Off"]}
          value={isAutoSell ? "On" : "Off"}
          onChange={(v) => setIsAutoSell(v === "On")}
        />
      </div>
      <TpSlProfileModalWithBtnV2 />
    </div>
  );
};

export default AutoSellButtonsV2;
